<app-organizer-shared-layout-dashboard
  class="organizer-dates"
  [hasHeader]="hasHeader"
>
  <app-organizer-shared-header
    class="organizer-dates__header"
    [title]="activity.name"
    [backLink]="backLink"
  ></app-organizer-shared-header>

  <app-organizer-shared-activity-timeslot-list
    class="organizer-dates__timeslot-list"
    [activity]="activity"
    [timeslots]="timeslots"
    [hasPagination]="hasPagination"
    [hasLoadMoreButton]="hasLoadMoreButton"
    (loadMore)="loadMore()"
  >
  </app-organizer-shared-activity-timeslot-list>
</app-organizer-shared-layout-dashboard>
